import axios from 'axios';
import { mapActions, mapState } from 'vuex';
import dayjs from 'dayjs';
import dateFormat from '../../../../mixins/date-formater';
import domainMixin from '../../../../mixins/domain';

export default {
  mixins: [dateFormat, domainMixin],
  data() {
    return {
      period: [dayjs().subtract(1, 'year').startOf('month').format('YYYY-MM-DD'), dayjs().startOf('month').format('YYYY-MM-DD')],
      selectedAccrual: null,
      exportDisabled: true,
      limit: 12,
      offset: 0,
      currentPage: 1,
      noticeList: [],
      isDownloadingNotice: false,
      columns: [
        {
          label: 'Період',
          prop: 'date',
        },
        {
          label: 'Заборгованість на початок періоду',
          prop: 'startBalance',
        },
        {
          label: 'Номенклатура',
          prop: 'nomenclature',
        },
        {
          label: 'Кількість кубів',
          prop: 'number',
        },
        {
          label: 'Ціна з ПДВ(грн.)',
          prop: 'price',
        },
        {
          label: 'Сума продажу з ПДВ(грн.)',
          prop: 'sum',
        },
        {
          label: 'Оплачено',
          prop: 'paid',
        },
        {
          label: 'Заборгованість на кінець періоду',
          prop: 'endBalance',
        },
      ],
      paymentsColumns: [
        {
          label: 'Документ',
          prop: 'document',
        },
        {
          label: 'Оплачено',
          prop: 'sum',
        },
      ],
    };
  },
  methods: {
    ...mapActions(['loadAccruals']),
    downloadAct(accrual) {
      window.open(
        `api/accrual/export-act?contractNumber=${this.contractNumber}&period=${accrual.date}`,
        '_blank'
      );
    },
    downloadActInvoice(accrual) {
      window.open(
        `api/accrual/export-act-invoice?contractNumber=${this.contractNumber}&period=${accrual.date}`,
        '_blank'
      );
    },
    handleCurrentChange(val) {
      this.exportDisabled = false;
      this.selectedAccrual = val;
    },
    prevClick() {
      this.offset -= this.limit;
      this.loadData();
    },
    nextClick() {
      this.offset += this.limit;
      this.loadData();
    },
    loadData() {
      this.loadAccruals({
        contractNumber: this.contractNumber,
        from: this.period[0],
        to: this.period[1],
        limit: this.limit,
        offset: this.offset,
      });
    },
    async fetchAvailableNotices() {
      if (!this.contractNumber) {
        this.noticeList = [];
        return;
      }
      try {
        const response = await axios.get('/api/accrual/information-notice/available', {
          params: { contractNumber: this.contractNumber },
        });
        this.noticeList = (response.data && response.data.notices) ? response.data.notices : [];
      } catch (err) {
        this.noticeList = [];
      }
    },
    async downloadInformationNotice(year) {
      if (!this.contractNumber) return;
      const targetYear = year || (this.noticeList[0] && this.noticeList[0].year);
      this.isDownloadingNotice = true;
      try {
        const response = await axios.get('/api/accrual/information-notice/download', {
          params: {
            contractNumber: this.contractNumber,
            year: targetYear,
          },
          responseType: 'blob',
        });

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute(
          'download',
          `Informative_Notice_${this.contractNumber}_${targetYear || ''}.pdf`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } catch (err) {
        this.$notify.error({
          title: 'Помилка завантаження',
          message: 'Не вдалося завантажити інформаційне повідомлення',
        });
      } finally {
        this.isDownloadingNotice = false;
      }
    },
  },
  computed: {
    ...mapState({
      accruals: (state) => state.Accruals.accruals,
      total: (state) => state.Accruals.total,
      contractNumber: (state) => state.Auth.currentCompany.contractNumber,
      loading: (state) => state.Accruals.loading,
    }),
  },
  watch: {
    period() {
      this.offset = 0;
      this.currentPage = 1;
      this.loadData();
    },
    contractNumber() {
      this.offset = 0;
      this.currentPage = 1;
      this.loadData();
      this.fetchAvailableNotices();
    },
  },
  beforeMount() {
    this.loadData();
    this.fetchAvailableNotices();
  },
};
